"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTrailingSlash = void 0;
function withTrailingSlash(route) {
    return route.endsWith('/') ? route : `${route}/`;
}
exports.withTrailingSlash = withTrailingSlash;
//# sourceMappingURL=index.js.map